import React, { useState, useEffect } from 'react';
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  SelectChangeEvent,
  CircularProgress,
  Box,
  FormHelperText
} from '@mui/material';
import api from '../../services/useApi';

interface PerfisOnuSelectProps {
  oltId: number | string;
  caixaId?: number | string;
  value: string | number;
  onChange: (value: string | number) => void;
  label?: string;
  disabled?: boolean;
  required?: boolean;
  fullWidth?: boolean;
  size?: 'small' | 'medium';
  error?: boolean;
  helperText?: string;
}

interface Perfil {
  id: number;
  descricao: string;
  comandos: string;
  status: boolean;
}

const PerfisOnuSelect: React.FC<PerfisOnuSelectProps> = ({
  oltId,
  caixaId,
  value,
  onChange,
  label = 'Perfil ONU',
  disabled = false,
  required = false,
  fullWidth = true,
  size = 'small',
  error = false,
  helperText = ''
}) => {
  const [perfis, setPerfis] = useState<Perfil[]>([]);
  const [loading, setLoading] = useState(false);
  const [fetchError, setFetchError] = useState<string | null>(null);

  useEffect(() => {
    if (oltId) {
      fetchPerfis();
    } else {
      setPerfis([]);
    }
  }, [oltId, caixaId]);

  const fetchPerfis = async () => {
    setLoading(true);
    setFetchError(null);

    try {
      const response = await api.get('/ftth-olt-perfis-onu', {
        params: {
          olt_id: oltId,
          caixas_id: caixaId,
          status: 'true'
        }
      });

      const data = response.data.data || response.data;
      setPerfis(Array.isArray(data) ? data : []);
    } catch (err: any) {
      console.error('Erro ao buscar perfis ONU:', err);
      setFetchError('Erro ao carregar perfis');
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (event: SelectChangeEvent<string | number>) => {
    onChange(event.target.value);
  };

  return (
    <FormControl
      fullWidth={fullWidth}
      size={size}
      disabled={disabled || loading}
      required={required}
      error={error || !!fetchError}
    >
      <InputLabel id="perfil-onu-select-label">{label}</InputLabel>
      <Select
        labelId="perfil-onu-select-label"
        id="perfil-onu-select"
        value={value || ''}
        label={label}
        onChange={handleChange}
        startAdornment={loading && <CircularProgress size={20} sx={{ mr: 1 }} />}
      >
        <MenuItem value="">
          <em>Selecione um perfil</em>
        </MenuItem>
        {perfis.map((perfil) => (
          <MenuItem key={perfil.id} value={perfil.id}>
            {perfil.descricao}
          </MenuItem>
        ))}
      </Select>
      <FormHelperText>{helperText || fetchError}</FormHelperText>
    </FormControl>
  );
};

export default PerfisOnuSelect;
